import { render, staticRenderFns } from "./DiagnosesBlock.vue?vue&type=template&id=94815912&lang=pug&"
import script from "./DiagnosesBlock.vue?vue&type=script&lang=js&"
export * from "./DiagnosesBlock.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosesBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports